package com.milta.core.localization.translations.nl

import com.milta.core.localization.OcrScanStrings

internal val OcrScan = OcrScanStrings(
    scanTitle = "Document scannen",
    reviewTitle = "Gegevens controleren",
    fileSentSuffix = "net verzonden",
    analysingTitle = "Document wordt gelezen…",
    analysingSubtitle = "We detecteren de leveringen op de foto. Dit duurt maar een paar seconden.",
    deliveriesDetectedSuffix = "leveringen gedetecteerd",
    toCompleteSuffix = "aan te vullen",
    reviewHint = "Vul de gemarkeerde leveringen aan voordat u ze aan de rit toevoegt",
    addressMissingWarning = "Adres ontbreekt",
    nameMissingWarning = "Naam ontbreekt",
    recipientMissingPlaceholder = "Geen ontvanger gedetecteerd",
    phoneNotDetectedNote = "Telefoon niet gedetecteerd — toevoegen niet geblokkeerd",
    deadlineLabelPrefix = "Uiterste tijd",
    completeLinkLabel = "Aanvullen",
    addToRouteButtonPrefix = "Toevoegen aan de rit",
    correctionRecipientLabel = "Ontvanger",
    correctionAddressLabel = "Adres",
    correctionPhoneLabel = "Telefoon",
    correctionDeadlineLabel = "Uiterste tijd",
    unreadableTitle = "Foto onleesbaar.",
    unreadableMessage = "We hebben geen enkele levering op deze afbeelding gedetecteerd — maak een nieuwe, goed gekaderde en goed belichte foto.",
    retakePhotoButton = "Nieuwe foto maken",
    manualEntryButton = "Handmatig invoeren",
    rateLimitTitle = "Onlangs te veel scans uitgevoerd.",
    rateLimitMessage = "Probeer het later opnieuw, of vul deze levering ondertussen handmatig aan.",
    rateLimitRetakeUnavailableLabel = "Nieuwe foto maken — momenteel niet beschikbaar",
)
